<template>
  <div>
    <modal-padrao
      ref="modal-requisitos"
      max-width="80%"
      titulo="Requisitos"
      titulo-cancelar="Fechar"
      :mostra-botao-salvar="false"
    >
      <div class="informativo-container mt-2" v-if="registroInformativo">
        <div class="informativo-texto">
          {{
            `Último Registro de Informativo ${registroInformativo?.ultimoRegistro}, `
          }}
          {{
            `data de emissão: ${formatarData(
              registroInformativo?.dataEmissao
            )}, `
          }}
          {{ `nome: ${registroInformativo?.nome}. ` }}
        </div>
        <botao-padrao
          v-if="buscarPermissao('RegistroInformativo', 'Visualizar')"
          @click="abrirModalRegistro"
          class="informativo-botao"
        >
          {{ $t('modulos.orcamentos.registro_informativos') }}
        </botao-padrao>
      </div>
      <div v-for="(item, index) in requisitosCliente" :key="index">
        <accordion-padrao
          :alterar-cor="true"
          cor-azul-texto
          :titulo="
            $t(
              `modulos.participantes.formulario.requisitos.${item.tipoRequisito}`
            )
          "
          class="accordion-padrao mb-5"
        >
          <div
            v-for="(requisitoItem, index) in item.requisitos"
            :key="index"
            class="d-flex"
          >
            <p>
              <span
                v-if="
                  requisitoItem.classificacaoRequisito == 'CampoAdicional' ||
                  requisitoItem.classificacaoRequisito == 'TextoLivre'
                "
                class="ml-10"
                v-html="requisitoItem.descricao"
              >
              </span>
            </p>
          </div>

          <accordion-padrao
            v-if="item.descricaoTipoDocumentoGeral"
            cor-azul-texto
            cor-texto="#0038ff"
            alterar-cor
            :titulo="'Documentos Necessários'"
            class="accordion-padrao ml-10"
          >
            <span
              :key="index"
              class="d-flex ml-10"
              v-html="item.descricaoTipoDocumentoGeral"
            >
            </span>
          </accordion-padrao>
        </accordion-padrao>
      </div>
      <strong class="d-flex mt-12 mb-3">
        {{ $t('modulos.orcamentos.dados_aba_requisitos') }}
      </strong>
    </modal-padrao>
    <registro-informativo-modal
      ref="registro-informativo-modal"
      :form="registroInformativo"
    />
  </div>
</template>
<script>
import helpers from '@common/utils/helpers';
import RegistroInformativoModal from '@views/modulos/cadastros/operacao/components/modais/RegistroInformativoModal.vue';

export default {
  components: {
    RegistroInformativoModal,
  },
  props: {
    requisitosCliente: {
      type: Array,
      default: () => {
        return [];
      },
    },
    registroInformativo: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  watch: {
    requisitosCliente() {
      this.formataDadosParaExibicao();
    },
  },
  mounted() {
    this.formataDadosParaExibicao();
  },
  methods: {
    formatarData(data) {
      return helpers.formatarDataBr(data);
    },
    buscarPermissao(funcionalidade, funcionalidadeAcao) {
      return helpers.buscarStatePermissoes(
        this,
        funcionalidade,
        funcionalidadeAcao
      );
    },
    abrirModal: function () {
      this.$refs['modal-requisitos'].abrirModal();
    },
    abrirModalRegistro: function () {
      this.$refs['registro-informativo-modal'].abrirModal();
    },
    formataDadosParaExibicao() {
      if (this.requisitosCliente) {
        this.requisitosCliente.map((item) => {
          item.descricaoTipoDocumentoGeral = '';
        });

        this.requisitosCliente.map((item) => {
          if (item.requisitos.length) {
            item.requisitos.map((itemRequisito) => {
              if (itemRequisito.classificacaoRequisito == 'TipoDocumento') {
                item.descricaoTipoDocumentoGeral += itemRequisito.descricao
                  ? itemRequisito.descricao + '<br>'
                  : '';
              }
            });
          }
        });
        this.requisitosCliente.map((item) => {
          if (item.requisitos.length) {
            item.requisitos.map((itemRequisito) => {
              itemRequisito.descricao = itemRequisito.descricao.replaceAll(
                '\n',
                '<br>&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp'
              );
            });
          }
        });
      }
    },
  },
};
</script>
<style>
.accordion-padrao {
  color: #0d47a1;
}
.informativo-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.informativo-texto {
  flex-grow: 1;
}

.informativo-botao {
  margin-left: auto;
}
</style>
